import { timestampToIsoFormat } from '@atlaskit/editor-common/utils';
import { getText } from '../../utils';
var date = function date(node, schema) {
  return node.attrs.timestamp ? timestampToIsoFormat(node.attrs.timestamp) : getText(node);
};
export default date;